import React from 'react';
import {createRoot} from 'react-dom/client';
import WebLogin from './containers/weblogin/WebLogin';
import {Provider} from 'react-redux'
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom';
import store, {history} from './store'
import './index.css';
import '@imprivata/common-auth-ui/build/common-auth-ui.css'
import '@imprivata/nucleus/build/nucleus.css'

console.log("WebLogin: Starting application...");
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
      <HistoryRouter history={history}>
        <WebLogin/>
      </HistoryRouter>
    </Provider>
);
